import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../constant/constant";
import axios from "axios";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [strength, setStrength] = useState({ label: "", color: "" });
const navigate = useNavigate();
  const rules = [
    { regex: /.{8,}/, message: "At least 8 characters" },
    { regex: /[A-Z]/, message: "At least 1 uppercase letter" },
    { regex: /[0-9]/, message: "At least 1 number" },
    { regex: /[^A-Za-z0-9]/, message: "At least 1 special character" },
  ];

  // Strength meter calculation
  const checkStrength = (pwd) => {
    let score = 0;
    if (pwd.length >= 8) score++;
    if (/[A-Z]/.test(pwd)) score++;
    if (/[0-9]/.test(pwd)) score++;
    if (/[^A-Za-z0-9]/.test(pwd)) score++;

    if (score === 0) return { label: "", color: "" };
    if (score === 1) return { label: "Weak", color: "red" };
    if (score === 2) return { label: "Fair", color: "orange" };
    if (score === 3) return { label: "Good", color: "blue" };
    if (score === 4) return { label: "Strong", color: "green" };
  };

  const handlePasswordChange = (e) => {
    const pwd = e.target.value;
    setPassword(pwd);
    setStrength(checkStrength(pwd));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate rules
    const failed = rules.filter((r) => !r.regex.test(password));
    if (failed.length > 0) {
      setMessage("❌ Password does not meet all requirements");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("❌ Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(
        `${API_BASE_URL}/api/reset-userpassword/${token}`,
        { newPassword: password },
        { headers: { "Content-Type": "application/json" } }
      );

      setMessage(res.data.message);
if (res.data.message.includes("successfully")) {
        setTimeout(() => navigate("/"), 2000); // redirect after 2s
      }


    } catch (err) {
      setMessage(err.response?.data?.message || "Error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #89f7fe, #66a6ff)",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          padding: "40px",
          borderRadius: "20px",
          background: "#fff",
          boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
          textAlign: "center",
          width: "100%",
          maxWidth: "400px",
        }}
      >
        <h2 style={{ marginBottom: "20px", color: "#333" }}>🔑 Reset Password</h2>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={handlePasswordChange}
            required
            style={{
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #ccc",
              fontSize: "1rem",
              outline: "none",
            }}
          />

          {/* Password Strength Meter */}
          {strength.label && (
            <div style={{ textAlign: "left", fontSize: "0.9rem" }}>
              <div
                style={{
                  height: "6px",
                  borderRadius: "5px",
                  background: strength.color,
                  width:
                    strength.label === "Weak"
                      ? "25%"
                      : strength.label === "Fair"
                      ? "50%"
                      : strength.label === "Good"
                      ? "75%"
                      : "100%",
                  transition: "width 0.3s ease",
                  marginBottom: "5px",
                }}
              ></div>
              <span style={{ color: strength.color }}>
                Password Strength: {strength.label}
              </span>
            </div>
          )}

          {/* Live Checklist */}
          <ul style={{ textAlign: "left", fontSize: "0.9rem", margin: 0, paddingLeft: "15px" }}>
            {rules.map((rule, idx) => {
              const valid = rule.regex.test(password);
              return (
                <li
                  key={idx}
                  style={{
                    color: valid ? "green" : "red",
                    listStyle: "none",
                    marginBottom: "5px",
                  }}
                >
                  {valid ? "✅" : "❌"} {rule.message}
                </li>
              );
            })}
          </ul>

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={{
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #ccc",
              fontSize: "1rem",
              outline: "none",
            }}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "12px",
              borderRadius: "10px",
              background: loading ? "#aaa" : "#4CAF50",
              color: "#fff",
              fontSize: "1rem",
              cursor: loading ? "not-allowed" : "pointer",
              border: "none",
              transition: "0.3s",
            }}
          >
            {loading ? "⏳ Resetting..." : "Reset Password"}
          </button>
        </form>

        {/* Feedback Message */}
        {message && (
          <p
            style={{
              marginTop: "20px",
              fontSize: "1rem",
              color: message.includes("success") ? "green" : "red",
            }}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
}
